import { createSlice } from '@reduxjs/toolkit';

const initialImageEditorState = {
    showImageEditorModal: false,
    image: null,
    pageIndex: null,
    childIndex: null,
    aspect: 16 / 9,
    rotate: 0,
    scale: 1,
    crop: undefined,
    completedCrop: undefined,
}

const imageEditorSlice = createSlice({
    name: 'imageEditor',
    initialState: initialImageEditorState,
    reducers: {
        showImageEditorModal(state, actions) {
            state.image = actions.payload.image;
            state.pageIndex = actions.payload.pageIndex;
            state.childIndex = actions.payload.childIndex;
            state.showImageEditorModal = true;
        },
        closeImageEditorModal(state) {
            state.showImageEditorModal = false;
            state.image = null;
            state.pageIndex = null;
            state.childIndex = null;
            state.aspect = 16 / 9;
            state.rotate = 0;
            state.scale = 1;
            state.crop = undefined;
            state.completedCrop = undefined;
        },
        updateImage(state, actions) {
            state.image = actions.payload;
        },
        setAspect(state, actions) {
            state.aspect = actions.payload;
        },
        setRotate(state, actions) {
            state.rotate = actions.payload;
        },
        setScale(state, actions) {
            state.scale = actions.payload;
        },
        setCrop(state, actions) {
            state.crop = actions.payload;
        },
        setCompletedCrop(state, actions) {
            state.completedCrop = actions.payload;
        }
    }
})

export const imageEditorActions = imageEditorSlice.actions;
export default imageEditorSlice;